import { createStore } from 'satcheljs';
export default createStore('safeSendersOption', {
    safeSenders: null,
})();
//# sourceMappingURL=store.js.map